export default __webpack_public_path__ + "static/media/SambinoIcon.eff98b14.jpg";